module.exports = __webpack_public_path__ + "static/img/waiting_pay.a5df6e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/waiting_pay.png
// module id = DsQj
// module chunks = 0